import React from 'react'
import icon1 from "../../media/images/img-1.png";
import icon2 from "../../media/images/img-2.png";
import icon3 from "../../media/images/img-3.png";
import icon4 from "../../media/images/img-4.png";

import CountUp from "react-countup";


const NumbersIncrement = () => {
  return (
    <div>

        
<div className="about-company-numbers">
  <div className="about-company-numbers-main">


            <div className="about-company-numbers-col">
              <div className="about-company-numbers-icon">
                <div></div>
                <img
                  src={icon1}
                  alt=""
                />
              </div>
              <div className="about-company-numbers-content">
                <div className="about-company-numbers-content-number">
                  <CountUp end={100} duration="4" enableScrollSpy />
                </div>
                <div className="about-company-numbers-content-text">
                  <span>Member</span>
                  <div>Professional</div>
                </div>
              </div>
            </div>

            <div className="about-company-numbers-col">
              <div className="about-company-numbers-icon">
                <div></div>
                <img
                  src={icon2}
                  alt=""
                />
              </div>
              <div className="about-company-numbers-content">
                <div className="about-company-numbers-content-number">
                  <CountUp end={100000} duration="4" enableScrollSpy />
                </div>
                <div className="about-company-numbers-content-text">
                  <span>Services</span>
                  <div>Completed</div>
                </div>
              </div>
            </div>

            <div className="about-company-numbers-col">
              <div className="about-company-numbers-icon">
                <div></div>
                <img
                                    src={icon3}
alt=""
                />
              </div>
              <div className="about-company-numbers-content">
                <div className="about-company-numbers-content-number">
                  <CountUp end={10} duration="4" enableScrollSpy /> +
                </div>
                <div className="about-company-numbers-content-text">
                  <span>Total</span>
                  <div>Branches</div>
                </div>
              </div>
            </div>

            <div className="about-company-numbers-col">
              <div className="about-company-numbers-icon">
                <div></div>
                <img
                                    src={icon4}
alt=""
                />
              </div>
              <div className="about-company-numbers-content">
                <div className="about-company-numbers-content-number">
                  <CountUp end={70000} duration="4" enableScrollSpy />
                </div>
                <div className="about-company-numbers-content-text">
                  <span>Client</span>
                  <div>Satisfaction</div>
                </div>
              </div>
            </div>

          </div>

          
            <div className="cta-button">
              <a href="#book-now">Book Service Now</a>
            </div>


          </div>
            
        
        
    </div>
  )
}

export default NumbersIncrement